import React from "react";
import { IViewLeadDetailsProps } from "./ViewLeadDetails.types";
import {
  Box,
  Button,
  Divider,
  Grid,
  List,
  ListItemButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../redux/initialStoreState";
import { Phone } from "@mui/icons-material";
import { ILead } from "../../../../redux/leads/leads.types";
import { RightPanel } from "../../../../components/RightPanel";
import { StatusRenderer } from "../../../../components/ActiveInActiveStatus/ActiveInActiveStatus";
import { useTimezoneFormatter } from "../../../../hooks/useTimezoneFormatter";

export const ViewLeadDetails: React.FC<IViewLeadDetailsProps> = (props) => {
  const { open, onClose } = props;

  const { ftDate } = useTimezoneFormatter();

  const { list } = useSelector(
    (storeState: IStoreState) => storeState.leads.list,
  );

  const [selectedLead, setSelectedLead] = React.useState(props.lead);

  const handleSelectLead = (lead: ILead) => () => {
    setSelectedLead(lead);
  };

  return (
    <RightPanel
      open={open}
      heading="Lead Summary"
      onClose={onClose}
      width="65%"
      actionButtons={() => (
        <Stack direction={"row"} spacing={2} justifyContent={"flex-end"}>
          <Button variant="contained" type="button" onClick={onClose}>
            Close
          </Button>
        </Stack>
      )}
    >
      <Grid container spacing={2} height={"100%"}>
        <Grid item xs={0} display={{ xs: "none", md: "block" }} md={3}>
          <Paper
            variant="outlined"
            sx={{ height: "100%", maxHeight: "82vh", overflowY: "auto" }}
          >
            <List disablePadding>
              {list.map((lead, index) => {
                return (
                  <>
                    <ListItemButton
                      key={lead.leads_uuid}
                      selected={lead.leads_uuid === selectedLead.leads_uuid}
                      onClick={handleSelectLead(lead)}
                    >
                      <Box
                        key={lead.leads_uuid}
                        minHeight={50}
                        width={"100%"}
                        padding={1}
                      >
                        <Stack>
                          <Stack
                            direction={"row"}
                            justifyContent={"space-between"}
                          >
                            <Typography
                              variant="h5"
                              fontSize={"1.1rem"}
                              fontWeight={600}
                            >
                              {lead.name_of_guest}
                            </Typography>
                            <StatusRenderer status={lead.status} />
                          </Stack>
                          <Stack
                            direction={"row"}
                            justifyContent={"space-between"}
                          >
                            <Typography variant="body1">
                              {lead.preferred_venue}
                            </Typography>
                          </Stack>

                          <Stack
                            direction={"row"}
                            justifyContent={"space-between"}
                          ></Stack>
                          <Stack
                            direction={"row"}
                            justifyContent={"space-between"}
                          >
                            <Typography
                              variant="body1"
                              sx={{ display: "flex", alignItems: "center" }}
                            >
                              <Phone
                                sx={{ mr: 1 }}
                                color="primary"
                                fontSize="small"
                              />
                              {lead.contact_number_one}
                            </Typography>
                            {/* <Typography
															variant="body1"
															color="error"
															textAlign={"end"}
														>
															{ftDate(lead.insert_ts)}
														</Typography> */}
                          </Stack>
                        </Stack>
                      </Box>
                    </ListItemButton>
                    <Divider />
                  </>
                );
              })}
            </List>
          </Paper>
        </Grid>
        <Grid item xs={12} md={9}>
          <Paper variant="outlined" sx={{ p: 3 }}>
            <Grid container spacing={2} mt={3}>
              <Grid item xs={12} md={12}>
                <Row
                  label="Guest Name"
                  value={selectedLead.name_of_guest}
                ></Row>
              </Grid>
              <Grid item xs={12} md={12}>
                <Row
                  label="Primary Phone Number(+91)"
                  value={selectedLead.contact_number_one}
                ></Row>
              </Grid>
              <Grid item xs={12} md={12}>
                <Row
                  label="Secondary Phone Number(+91)"
                  value={selectedLead.additional_contact_number
                    .map((contact) => contact.contact_number)
                    .join(", ")}
                ></Row>
              </Grid>
              <Grid item xs={12} md={12}>
                <Row
                  label="Followup Date"
                  value={ftDate(selectedLead.followup_date || "")}
                ></Row>
              </Grid>

              <Grid item xs={12} md={12}>
                <Row
                  label="Event Date"
                  value={ftDate(selectedLead.function_date || "")}
                ></Row>
              </Grid>
              <Grid item xs={12} md={12}>
                <Row label="Event Type" value={selectedLead.event_type}></Row>
              </Grid>
              <Grid item xs={12} md={12}>
                <Row label="Event Time" value={selectedLead.event_time}></Row>
              </Grid>
              <Grid item xs={12} md={12}>
                <Row
                  label="Preferred Venue"
                  value={selectedLead.preferred_venue}
                ></Row>
              </Grid>
              <Grid item xs={12} md={12}>
                <Row
                  label="Number of Guests"
                  value={selectedLead.number_of_guests}
                ></Row>
              </Grid>
              <Grid item xs={12} md={12}>
                <Row
                  label="Number of Rooms"
                  value={selectedLead.number_of_rooms}
                ></Row>
              </Grid>

              <Grid item xs={12} md={12}>
                <Row
                  label="Handled By"
                  value={selectedLead.handled_by_employee}
                ></Row>
              </Grid>

              <Grid item xs={12} md={12}>
                <Row label="status" value={selectedLead.status}></Row>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </RightPanel>
  );
};

export const Row: React.FC<{
  label: string;
  value: any;
  fontSize?: string;
  fontWeight?: number;
  valueFontSize?: string;
}> = ({ label, value, fontSize, fontWeight, valueFontSize }) => {
  return (
    <Stack
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <Typography
        variant="body1"
        fontSize={fontSize ? fontSize : "1.1rem"}
        fontWeight={fontWeight ? fontWeight : 600}
      >
        {label}
      </Typography>
      <Typography
        variant="body1"
        fontSize={valueFontSize ? valueFontSize : "1.1rem"}
      >
        {value}
      </Typography>
    </Stack>
  );
};
